var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartShuttleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 65,
    viewBox: "0 0 64 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_207_32258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0841 21.4156L58.9554 20.2226C58.8754 19.4726 58.6002 18.7532 58.1562 18.1436L57.7744 17.6172C57.0508 16.6216 55.8787 16.0251 54.6357 16.0251H53.6545C53.5435 14.933 53.4236 13.9022 53.2993 12.9504C52.9309 10.1477 51.1728 7.77486 48.5978 6.61255C45.3925 5.16514 39.9274 3.44141 32.0915 3.44141C24.2557 3.44141 18.7018 5.27479 15.7006 6.81869C13.5385 7.92837 12.0069 9.94597 11.4963 12.3495C11.2699 13.4198 11.0568 14.6479 10.8615 16.0207H9.80043C8.55734 16.0207 7.3853 16.6172 6.66609 17.6129L6.28428 18.1392C5.84033 18.7532 5.56507 19.4726 5.48516 20.2182L5.35641 21.4112C5.26762 22.2358 5.53844 23.0604 6.10226 23.6788C6.66609 24.2972 7.46521 24.6481 8.30429 24.6481H10.0313C9.75159 29.1263 9.60508 34.2844 9.60508 40.0214C9.60508 55.2937 10.5995 63.9431 11.4297 68.5046C11.9581 71.3863 14.3998 73.4828 17.3743 73.6012C20.4909 73.7241 25.6364 73.8732 32.4378 73.8732C39.2392 73.8732 44.2204 73.7284 47.3459 73.61C50.458 73.4916 52.9841 71.1801 53.3526 68.123C53.9564 63.0834 54.68 54.184 54.68 40.3942C54.68 34.6967 54.5557 29.4114 54.3071 24.6437H56.1407C56.9797 24.6437 57.7833 24.2885 58.3427 23.6744C58.9021 23.0604 59.1773 22.2314 59.0885 21.4068L59.0841 21.4156Z",
    fill: "#3B495C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0841 21.4156L58.9554 20.2226C58.8754 19.4726 58.6002 18.7532 58.1562 18.1436L57.7744 17.6172C57.0508 16.6216 55.8787 16.0251 54.6357 16.0251H53.6545C53.5435 14.933 53.4236 13.9022 53.2993 12.9504C52.9309 10.1477 51.1728 7.77486 48.5978 6.61255C45.3925 5.16514 39.9274 3.44141 32.0915 3.44141C24.2557 3.44141 18.7018 5.27479 15.7006 6.81869C13.5385 7.92837 12.0069 9.94597 11.4963 12.3495C11.2699 13.4198 11.0568 14.6479 10.8615 16.0207H9.80043C8.55734 16.0207 7.3853 16.6172 6.66609 17.6129L6.28428 18.1392C5.84033 18.7532 5.56507 19.4726 5.48516 20.2182L5.35641 21.4112C5.26762 22.2358 5.53844 23.0604 6.10226 23.6788C6.66609 24.2972 7.46521 24.6481 8.30429 24.6481H10.0313C9.75159 29.1263 9.60508 34.2844 9.60508 40.0214C9.60508 55.2937 10.5995 63.9431 11.4297 68.5046C11.9581 71.3863 14.3998 73.4828 17.3743 73.6012C20.4909 73.7241 25.6364 73.8732 32.4378 73.8732C39.2392 73.8732 44.2204 73.7284 47.3459 73.61C50.458 73.4916 52.9841 71.1801 53.3526 68.123C53.9564 63.0834 54.68 54.184 54.68 40.3942C54.68 34.6967 54.5557 29.4114 54.3071 24.6437H56.1407C56.9797 24.6437 57.7833 24.2885 58.3427 23.6744C58.9021 23.0604 59.1773 22.2314 59.0885 21.4068L59.0841 21.4156Z",
    stroke: "#3B495C",
    strokeWidth: 3,
    fill: "#000000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0841 18.3648L58.9554 17.1718C58.8754 16.4218 58.6002 15.7025 58.1562 15.0928L57.7744 14.5665C57.0508 13.5708 55.8787 12.9743 54.6357 12.9743H53.6545C53.5435 11.8822 53.4236 10.8514 53.2993 9.89966C52.9309 7.09695 51.1728 4.72408 48.5978 3.56177C45.3925 2.11436 39.9274 0.390625 32.0915 0.390625C24.2557 0.390625 18.7018 2.22401 15.7006 3.76791C13.5385 4.87759 12.0069 6.89519 11.4963 9.29877C11.2699 10.369 11.0568 11.5971 10.8615 12.9699H9.80043C8.55734 12.9699 7.3853 13.5664 6.66609 14.5621L6.28428 15.0884C5.84033 15.7025 5.56507 16.4218 5.48516 17.1674L5.35641 18.3604C5.26762 19.185 5.53844 20.0096 6.10226 20.628C6.66609 21.2465 7.46521 21.5974 8.30429 21.5974H10.0313C9.75159 26.0755 9.60508 31.2336 9.60508 36.9706C9.60508 52.2429 10.5995 60.8923 11.4297 65.4538C11.9581 68.3355 14.3998 70.432 17.3743 70.5505C20.4909 70.6733 25.6364 70.8224 32.4378 70.8224C39.2392 70.8224 44.2204 70.6777 47.3459 70.5592C50.458 70.4408 52.9841 68.1293 53.3526 65.0722C53.9564 60.0326 54.68 51.1333 54.68 37.3434C54.68 31.6459 54.5557 26.3606 54.3071 21.593H56.1407C56.9797 21.593 57.7833 21.2377 58.3427 20.6236C58.9021 20.0096 59.1773 19.1806 59.0885 18.356L59.0841 18.3648Z",
    fill: "#070A0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6356 14.7305H9.79976C9.12939 14.7305 8.49897 15.0507 8.10828 15.5901L7.72648 16.1165C7.46011 16.4805 7.29584 16.9104 7.24701 17.3577L7.11826 18.5507C7.04279 19.2437 7.59329 19.849 8.29919 19.849H13.6311V14.7305H13.6356Z",
    fill: "#697B96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.1812L7.21901 18.3402C7.2692 18.1438 7.54753 18 7.87605 18H13V20H8.34601C7.60228 20 7 19.6321 7.00456 19.1812H7Z",
    fill: "#122D59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8047 14.7305H54.6405C55.3109 14.7305 55.9413 15.0507 56.332 15.5901L56.7138 16.1165C56.9801 16.4805 57.1444 16.9104 57.1932 17.3577L57.322 18.5507C57.3974 19.2437 56.8469 19.849 56.1411 19.849H50.8091V14.7305H50.8047Z",
    fill: "#697B96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 19.1812L56.781 18.3402C56.7308 18.1438 56.4524 18 56.1239 18H51V20H55.6585C56.4023 20 57.0045 19.6321 57 19.1812Z",
    fill: "#122D59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5856 64.8704C51.3237 67.0547 49.499 68.7258 47.2748 68.8135C44.1005 68.9363 39.0216 69.0767 32.4378 69.0767C25.8539 69.0767 20.553 68.9275 17.4453 68.8047C15.3321 68.7214 13.5518 67.2038 13.1789 65.1467C12.4108 60.9361 11.3809 52.4139 11.3809 36.9749C11.3809 21.5359 12.4597 13.2901 13.2322 9.66276C13.6273 7.80745 14.8171 6.20214 16.5219 5.32492C19.2345 3.93015 24.2467 2.14062 32.1003 2.14062C39.954 2.14062 44.8464 3.78979 47.8697 5.15386C49.8853 6.06178 51.266 7.95219 51.5501 10.1189C52.1006 14.3208 52.9042 22.9263 52.9042 37.3477C52.9042 51.7692 52.1406 60.3001 51.5901 64.8704H51.5856Z",
    fill: "url(#paint0_linear_207_32258)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0216 37.5688L17.1614 50.6306C17.0548 51.3894 17.6187 52.0736 18.3911 52.1219C20.9883 52.2798 26.7287 52.5868 32.2692 52.5868C37.8098 52.5868 43.5546 52.2798 46.1518 52.1219C46.9243 52.0736 47.4881 51.3894 47.3815 50.635L45.5658 37.5732C45.4903 37.0293 45.0064 36.639 44.4559 36.6741C42.6978 36.7881 38.5868 36.9986 32.2692 36.9986C25.9517 36.9986 21.8806 36.7881 20.1359 36.6741C19.5854 36.639 19.1015 37.0293 19.026 37.5688H19.0216Z",
    fill: "url(#paint1_linear_207_32258)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4628 66.7798L50.1373 56.9482C50.1909 55.6967 49.6458 54.571 48.8283 55.0841L46.7916 56.3662C45.8982 56.9231 44.9334 57.211 43.9552 57.211H20.5933C19.615 57.211 18.6502 56.9231 17.7568 56.3662L16.0862 55.3212C15.2688 54.8081 14.2473 55.1148 14.3009 56.3663L15.0856 66.7798L32.2199 67.8546L49.4628 66.7798Z",
    fill: "url(#paint2_linear_207_32258)",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5201 50.8183L17.8845 30.9078L13.8516 30.1113L14.5201 50.8183Z",
    fill: "#122D59"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5325 17.7971L17.1662 19.0703C17.6102 19.4151 17.8632 19.9126 17.8632 20.4376V30.6744C17.8632 31.9124 17.5835 33.1386 17.0419 34.2787L15.1107 38.3334C14.8843 38.8035 14.0896 38.6743 14.0763 38.165C14.0274 36.2884 13.8516 33.3708 13.8516 28.9164C13.8516 23.0086 14.5025 19.3955 14.7733 18.0283C14.8354 17.7148 15.2616 17.5856 15.5325 17.7971Z",
    fill: "#122D59"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8417 16.0507L19.9494 19.1604C20.2513 19.463 20.6997 19.5815 21.1125 19.463C22.622 19.0288 26.6487 18.0507 32.3003 18.0507C37.9518 18.0507 41.7344 19.02 43.1639 19.4586C43.5635 19.5815 43.9985 19.4806 44.3093 19.1999L47.7411 16.0594C48.1007 15.7305 48.0385 15.1559 47.6124 14.9147C45.8898 13.9366 41.2549 11.9277 32.2692 11.9277C23.2835 11.9277 18.653 13.9629 16.9882 14.9322C16.5797 15.1691 16.5132 15.7173 16.8417 16.0507Z",
    fill: "url(#paint3_linear_207_32258)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7172 12.2797C16.7001 12.5469 17.0071 12.7264 17.2543 12.5908C18.7081 11.7931 23.0652 9.83075 32.3847 9.83075C41.7042 9.83075 45.7202 11.6854 47.191 12.519C47.4425 12.6626 47.758 12.4711 47.7282 12.1959L47.5107 10.1817C47.4638 9.73503 47.2038 9.33219 46.803 9.08092L46.5813 8.94132C45.5113 8.26727 44.7012 7.29808 44.2579 6.16536L44.1044 5.77449C43.9339 5.33576 43.5672 4.99275 43.0983 4.8372C41.6743 4.35859 38.1955 3.44922 32.3506 3.44922C26.5056 3.44922 22.8861 4.36258 21.4067 4.8372C20.9207 4.99275 20.5413 5.34772 20.3708 5.79842L20.034 6.69582C19.6801 7.64109 18.9852 8.43878 18.0686 8.95728L17.6124 9.21653C17.1563 9.47179 16.8664 9.92248 16.8365 10.4171L16.7129 12.2757L16.7172 12.2797Z",
    fill: "#E5EFFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1827 9.26459C14.0717 9.576 14.3913 9.86987 14.6932 9.72951C15.5234 9.34354 16.8997 8.63738 17.8675 7.78648C18.8354 6.93558 18.9774 6.14608 18.9863 5.65484C18.9907 5.40483 18.7421 5.225 18.4979 5.30395C18.0052 5.46185 17.1217 5.84783 15.9896 6.75575C14.9374 7.60226 14.4269 8.59352 14.1827 9.26459Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6357 9.26459C50.7467 9.576 50.427 9.86987 50.1252 9.72951C49.295 9.34354 47.9187 8.63738 46.9509 7.78648C45.983 6.93558 45.841 6.14608 45.8321 5.65484C45.8277 5.40483 46.0763 5.225 46.3204 5.30395C46.8132 5.46185 47.6967 5.84783 48.8288 6.75575C49.881 7.60226 50.3915 8.59352 50.6357 9.26459Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9318 59.4066L16.1361 61.4637C16.4293 62.6233 17.6241 63.3936 18.9034 63.2461L22.0349 62.8937C23.2164 62.7585 23.323 61.2178 22.1726 60.9473C22.1726 60.9473 21.071 60.763 19.1477 60.1401C18.3659 59.8901 17.362 59.3656 16.6647 58.9805C16.3227 58.792 15.8962 59.0419 15.9318 59.4066Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5077 59.4066L48.3034 61.4637C48.0102 62.6233 46.8153 63.3936 45.5361 63.2461L42.4046 62.8937C41.2231 62.7585 41.1165 61.2178 42.2669 60.9473C42.2669 60.9473 43.3685 60.763 45.2918 60.1401C46.0736 59.8901 47.0774 59.3656 47.7748 58.9805C48.1168 58.792 48.5432 59.0419 48.5077 59.4066Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.921 50.8179L46.5566 30.9073L50.5889 29.3145L49.921 50.8179Z",
    fill: "#122D59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9089 17.7971L47.2751 19.0703C46.8312 19.4151 46.5781 19.9126 46.5781 20.4376V30.6744C46.5781 31.9124 46.8578 33.1386 47.3994 34.2787L49.3307 38.3334C49.5571 38.8035 50.3518 38.6743 50.3651 38.165C50.4139 36.2884 50.5894 32.9725 50.5894 28.5182C50.5894 22.6104 49.9389 19.3955 49.6681 18.0283C49.6059 17.7148 49.1797 17.5856 48.9089 17.7971Z",
    fill: "#122D59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1035 21.2618L20.3211 35.0516C20.3211 35.0516 23.9837 35.6569 32.2013 35.6569C40.419 35.6569 44.1038 35.0516 44.1038 35.0516L44.2947 21.2618C44.2947 21.2618 41.7997 19.5117 32.0149 19.5117C22.2301 19.5117 20.1035 21.2618 20.1035 21.2618Z",
    fill: "#E5EFFA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_32258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 20C25.4112 20 26.0145 26.7365 26.0145 26.7365H26.085C26.5159 28.0157 28.9916 29 32 29C35.0084 29 37.4841 28.0157 37.915 26.7365H37.9855C37.9855 26.7365 38.5888 20 32 20Z",
    fill: "url(#paint4_linear_207_32258)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_207_32258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 24C33.6569 24 35 23.3284 35 22.5C35 21.6716 33.6569 21 32 21C30.3431 21 29 21.6716 29 22.5C29 23.3284 30.3431 24 32 24Z",
    fill: "#FFC2CA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_207_32258",
    x: 2.83984,
    y: 0.941406,
    width: 58.7656,
    height: 75.4316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_207_32258",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_207_32258",
    x: 28.6,
    y: 20.6,
    width: 6.8,
    height: 3.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_207_32258",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_32258",
    x1: 32.1425,
    y1: 2.14062,
    x2: 32.1425,
    y2: 69.0767,
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2E1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#879CBB",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_207_32258",
    x1: 32.6416,
    y1: 52.4219,
    x2: 32.6416,
    y2: 36.5965,
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122D59",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44618F",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_207_32258",
    x1: 32.275,
    y1: 57.1066,
    x2: 32.275,
    y2: 68.392,
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EFFA",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888201,
    stopColor: "#889DBC",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#879CBB",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_207_32258",
    x1: 32.3043,
    y1: 11.9277,
    x2: 32.3043,
    y2: 19.5102,
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34578F",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F3A67",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_207_32258",
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 29,
    gradientUnits: "userSpaceOnUse",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7a1b",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9b57",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_32258",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    fill: "white",
    transform: "translate(26 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartShuttleIcon);
export default __webpack_public_path__ + "static/media/cart_shuttle_icon.e3796f4fb852797a0be89d034ef2b924.svg";
export { ForwardRef as ReactComponent };